import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Handle the auth callback from email verification
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          toast({
            title: "Verification Error",
            description: "There was an issue verifying your email. Please try signing in.",
            variant: "destructive",
          });
          navigate('/');
          return;
        }

        if (data.session) {
          // User is now authenticated
          toast({
            title: "Email Verified! 🎉",
            description: "Welcome! Your account has been successfully verified. You can now access all lesson features.",
          });
          
          // Create student profile if it doesn't exist
          const { data: existingProfile } = await supabase
            .from('students_2025_10_21_13_22')
            .select('*')
            .eq('user_id', data.session.user.id)
            .single();

          if (!existingProfile && data.session.user.user_metadata?.name) {
            await supabase
              .from('students_2025_10_21_13_22')
              .insert([
                {
                  user_id: data.session.user.id,
                  name: data.session.user.user_metadata.name,
                  email: data.session.user.email || ''
                }
              ]);
          }
        } else {
          toast({
            title: "Please Sign In",
            description: "Please sign in to access your account.",
          });
        }
        
        // Redirect to main page
        navigate('/');
      } catch (error) {
        console.error('Callback handling error:', error);
        toast({
          title: "Something went wrong",
          description: "Please try signing in again.",
          variant: "destructive",
        });
        navigate('/');
      }
    };

    handleAuthCallback();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 via-purple-50 to-pink-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Verifying your email...</p>
        <p className="text-sm text-gray-500 mt-2">Please wait while we confirm your account</p>
      </div>
    </div>
  );
};